import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionZonaSalarialEditarComponent {
  editando
  proyectoId
  procesando
  error
  onClose

  constructor(FanProyectoConfiguracionZonaSalarial) {
    this.FanProyectoConfiguracionZonaSalarial = FanProyectoConfiguracionZonaSalarial
    this.opciones = [{ id: 'A', descripcion: 'D.F' }, { id: 'B', descripcion: 'Frontera' }]
    this.editando = false
    this.procesando = false
    this.error = null
  }

  $onInit() {
    this.copia = Object.assign({}, this.data)
  }

  actualizar() {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.FanProyectoConfiguracionZonaSalarial.put(this.proyectoId, this.data)
      .then(() => {
        this.form.$setPristine()
        this.onClose()
      })
      .catch((error) => (this.error = error.error))
      .finally(() => (this.procesando = false))
  }

  cerrar() {
    this.data = Object.assign(this.data, this.copia)
    this.onClose()
  }
}

module.component('fanProyectoConfigZonaSalarialEditar', {
  controller: FanProyectoConfiguracionZonaSalarialEditarComponent,
  template: template,
  bindings: {
    proyectoId: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/zonaSalarial/editar/component.js